import script from "./EntryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryTable.vue?vue&type=script&setup=true&lang=js"

import "./EntryTable.vue?vue&type=style&index=0&id=b129e1ae&lang=css"

const __exports__ = script;

export default __exports__